module.exports = __webpack_public_path__ + "static/media/login-image.78bea3db.png";